module.exports = __webpack_public_path__ + "img/icon_ts_gx@3x.1886d67c.png";